import { useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import AppTabItem from "../components/common/AppTabItem";
import LoadingSpinner from "../components/common/Loading";
import { scrollIntoView } from "../utils/utils";
import StaffInfoCard from "../components/profile-screen/staff-screen/staff-info-card";
import {
  getStaffPermissions,
  getStaffProfile,
} from "../features/staff/staffSlice";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useLocation } from "react-router-dom";
import { AuthRole } from "../utils/roles";
import { getAllComponents } from "../features/components/componentSlice";
import StaffPermissions from "../components/staff/staffPermision";

const StaffProfileScreen = () => {
  const { search } = useLocation();
  const { user_id }: any = AuthRole();

  let queryId: string = "";
  if (search) {
    queryId = search?.slice(10);
  } else {
    queryId = user_id;
  }
  const [selectedTab, setSelectedTab] = useState("Profile");
  const dispatch = useAppDispatch();
  //const { clinicId }: any = useAppSelector((state) => state.clinic);
  const { getStaffProfilePayload, isGetStaffProfileLoading }: any =
    useAppSelector((state) => state?.staff);
  const { allComponents }: any = useAppSelector((state) => state?.components);
  const setSelected = useCallback((item: string) => {
    setSelectedTab(item);
    scrollIntoView(item);
  }, []);

 // Get clinicId from local storage
 const parsedData = localStorage?.getItem("authToken");
 const userData = parsedData ? JSON?.parse(parsedData) : null;
 const clinicId = userData?.clinic_id || ""; // Default value if clinic_id is not available

  const getStaffProfileData = useCallback(() => {
    const obj = {
      clinic_id: clinicId,
      staff_id: queryId,
    };
    dispatch(getStaffProfile(obj));
    dispatch(getAllComponents());
    dispatch(getStaffPermissions(obj));
  }, [clinicId, dispatch, queryId]);

  useEffect(() => {
    getStaffProfileData();
  }, [getStaffProfileData, clinicId]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        padding: "1.2%",
      }}
    >
      {isGetStaffProfileLoading ? (
        <LoadingSpinner style={{ minHeight: "80vh" }} />
      ) : (
        <Box>
          {/* <Box
            sx={{
              width: "100%",
              typography: "body1",
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
              },
              alignItems: "center",
              bgcolor: "white",
              height: {
                md: "60px",
                sm: "280px",
                xs: "280px",
              },
            }}
          >
            <AppTabItem
              label="Profile"
              selected={selectedTab}
              setSelected={setSelected}
            />
            <AppTabItem
              label="Permissions"
              selected={selectedTab}
              setSelected={setSelected}
            />
          </Box> */}

          <Box sx={{ marginTop: 2 }}>
            <StaffInfoCard
              profileData={getStaffProfilePayload?.data}
              clinicId={clinicId}
              getProfileData={getStaffProfileData}
              queryId={queryId}
            />
          </Box>
          <Box sx={{ marginTop: 2, bgcolor: "white" }}>
            <StaffPermissions
              staff={allComponents}
              staffPermession={getStaffProfilePayload?.data?.permissions}
              clinicId={clinicId}
              staff_id={queryId}
              getStaff={getStaffProfileData}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default StaffProfileScreen;
